import { create } from 'zustand';
import type { CombinedAnalyzeRequest } from './types';

interface State {
  request: CombinedAnalyzeRequest;
  setSection: (p: Partial<CombinedAnalyzeRequest['section']>) => void;
  setMaterials: (p: Partial<CombinedAnalyzeRequest['materials']>) => void;
  setSoil: (p: Partial<CombinedAnalyzeRequest['soil']>) => void;
  setLoads: (p: Partial<CombinedAnalyzeRequest['loads']>) => void;
  setReinforcement: (p: Partial<CombinedAnalyzeRequest['reinforcement']>) => void;
  loadRequest: (req: CombinedAnalyzeRequest) => void;
}

const defaultRequest: CombinedAnalyzeRequest = {
  section: {
    L: 500, B: 200, Hf: 60, df: 150,
    bc1: 30, hc1: 30, x1: 50,
    bc2: 30, hc2: 30, x2: 450,
  },
  materials: { fc: 210, fy: 4200, cover: 7.5 },
  soil: { sigma_adm: 1.5, gamma_s: 1800, gamma_c: 2400, sigma_factor: 1.0 },
  loads: {
    P1: 40_000, M1: 0, Pu1: 60_000, Mu1: 0,
    P2: 40_000, M2: 0, Pu2: 60_000, Mu2: 0,
  },
  reinforcement: {
    diam_bot_long: '5/8', n_bot_long: 14,
    diam_top_long: '5/8', n_top_long: 6,
    diam_trans: '5/8', s_trans: 20,
  },
};

export const useCombinedStore = create<State>((set) => ({
  request: defaultRequest,
  setSection: (p) => set((s) => ({ request: { ...s.request, section: { ...s.request.section, ...p } } })),
  setMaterials: (p) => set((s) => ({ request: { ...s.request, materials: { ...s.request.materials, ...p } } })),
  setSoil: (p) => set((s) => ({ request: { ...s.request, soil: { ...s.request.soil, ...p } } })),
  setLoads: (p) => set((s) => ({ request: { ...s.request, loads: { ...s.request.loads, ...p } } })),
  setReinforcement: (p) => set((s) => ({ request: { ...s.request, reinforcement: { ...s.request.reinforcement, ...p } } })),
  loadRequest: (req) => set({ request: req }),
}));
